import type { JSX } from 'react';
import styles from './InfoStrip.module.scss';

interface InfoStripLogotypeProps {
  src: string;
  srcSet?: string;
  alt: string;
  // Intrinsic dimensions — required so the browser can reserve the right
  // amount of inline space before the asset loads (preventing CLS). The
  // visual size is controlled by CSS (.logotype height: 1.5lh, width: auto).
  width: number;
  height: number;
}

interface InfoStripProps {
  logotype?: InfoStripLogotypeProps;
  ariaLabel: string;
  heading?: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  description: string;
  action?: React.ReactNode;
  testId?: string;
}

export const InfoStrip = ({
  logotype,
  ariaLabel,
  heading,
  headingLevel = 2,
  description,
  action,
  testId,
}: InfoStripProps) => {
  const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements;

  return (
    <section className={styles.strip} aria-label={ariaLabel} data-testid={testId}>
      <div className={styles.content}>
        {logotype && (
          <img
            src={logotype.src}
            srcSet={logotype.srcSet}
            alt={logotype.alt}
            width={logotype.width}
            height={logotype.height}
            className={styles.logotype}
          />
        )}
        <div className={styles.text}>
          {heading && <HeadingTag className={styles.heading}>{heading}</HeadingTag>}
          <p className={styles.description}>{description}</p>
        </div>
      </div>
      {action}
    </section>
  );
};
